import { render, staticRenderFns } from "./IssueManageArticles.vue?vue&type=template&id=294b5da3&"
import script from "./IssueManageArticles.vue?vue&type=script&lang=ts&"
export * from "./IssueManageArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports